@if (usps.length) {
  <app-grid class="usps">
    <app-cell mobile="0:12">
      <div class="usps__pattern"></div>

      <div class="usps__swiper-container">
        <swiper [config]="swiperOptions"
          (swiper)="onSwiper($event)"
          >
          @for (usp of usps; track usp; let i = $index) {
            <ng-template swiperSlide>
              <div class="usps__usp-container">
                <ng-template [ngTemplateOutlet]="uspEl"
                  [ngTemplateOutletContext]="{ $implicit: usp }"
                ></ng-template>
                <div class="usps__middle-point">
                  <div class="usps__background-image"></div>
                </div>
              </div>
            </ng-template>
          }
        </swiper>

        <div class="usps__buttons-container">
          <app-button theme="line"
            layout="icon-only"
            icon="arrow-fat-left"
            (click)="previousSlide()"
            class="usps__button"
          ></app-button>

          <app-button theme="line"
            layout="icon-only"
            icon="arrow-fat-right"
            (click)="nextSlide()"
            class="usps__button--next"
          ></app-button>
        </div>
      </div>

      <div class="usps__pattern"></div>
    </app-cell>
  </app-grid>
}

<ng-template let-usp #uspEl>
  @if (usp | asUspFragment; as uspFragment) {
    <div class="usps__usp">
      <div class="usps__usp-icon-container">
        <span class="usps__usp-icon" [appIconEnum]="uspFragment.icon"></span>
      </div>
      <div class="usps__usp-text-container">
        <label class="usps__title">
          {{ uspFragment.title }}
        </label>
        <label class="usps__subtitle">
          {{ uspFragment.subtitle }}
        </label>
      </div>
    </div>
  }
</ng-template>
